import { DotsLoader } from 'app/common/components/Loader'

import Navigation from './Navigation'
import PoorNavigation from './PoorNavigation'
import styles from './NavigationRoot.scss'


type Props = {
  baseURL: string,
  isIteko: boolean,
  isSubscribed: boolean,
  isLoading: boolean,
  studentID: string,
  pathname: string,
  push: (path: string) => void,
  isCamp: boolean,
}

const NavigationRoot = ({
  baseURL,
  isIteko,
  isSubscribed,
  isLoading,
  studentID,
  pathname,
  push,
  isCamp,
}: Props) => {
  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <DotsLoader simple className={styles.loading} />
        &nbsp;
      </div>
    )
  }

  if (!isSubscribed) {
    return (
      <PoorNavigation
        studentID={studentID}
        baseURL={baseURL}
        pathname={pathname}
        push={push}
        isCamp={isCamp}
      />
    )
  }

  if (isSubscribed) {
    return (
      <Navigation
        baseURL={baseURL}
        isIteko={isIteko}
        isCamp={isCamp}
        studentID={studentID}
      />
    )
  }

  return null
}

export default NavigationRoot
